import formatInTimeZone from 'date-fns-tz/formatInTimeZone';

import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants';
import { type GetUserTimelineResponse } from '../../../common/types';

import { transformUserTimelineResponse } from './utils';

export const getWidgetTimeline = (accountId: string) => {
	const formattedCurrent = formatInTimeZone(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");

	const urlParams = new URLSearchParams({
		currentDate: formattedCurrent,
		accountId,
		mode: 'timeline',
		timelineType: '6',
	});

	return fetch<GetUserTimelineResponse>(
		`${urls.schedules.user.timeline.url()}?${urlParams.toString()}`,
		{
			method: 'GET',
		},
	).then(transformUserTimelineResponse);
};
